import React, { FC } from "react";

const DotGridBackground: FC<{
    dotSize?: number;
    spacing?: number;
    opacity?: number;
    color?: string;
}> = ({
          dotSize = 2,
          spacing = 15,
          opacity = 0.2,
          color = "#000",
      }) => {
    const radius = Math.max(1, Math.round(dotSize / 2));
    return (
        <div
            aria-hidden
            style={{
                position: "fixed",     // было absolute
                inset: 0,
                pointerEvents: "none",
                zIndex: 0,
                opacity,
                backgroundImage: `radial-gradient(${color} ${radius}px, transparent ${radius}px)`,
                backgroundSize: `${spacing}px ${spacing}px`,
                backgroundPosition: "0 0",
            }}
        />
    );
};

export default DotGridBackground;
